var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertStringToArray } from '../../../../../ui/utils/convertStringToArray';
import { occupationEcls } from '@juvare/credentialing/backend/constants';
import { getClassifierIdByName } from './getClassifierIdByName';
import { getClassifierIdsByNames } from './getClassifierIdsByNames';
import { getPostalCodeByName } from './getPostalCodeByName';
import { getPostalCodesByNames } from './getPostalCodesByNames';
import { validateOccupationsCriteria } from './missionPositionValidation';
export function mapCsvRowToData(row, withTrainCourses) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        let i = -1;
        const id = ((_a = row.data[++i]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[++i]) !== null && _b !== void 0 ? _b : '').trim();
        const status = ((_c = row.data[++i]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
        const occupationGroup = ((_d = row.data[++i]) !== null && _d !== void 0 ? _d : '').trim();
        const occupations = ((_e = row.data[++i]) !== null && _e !== void 0 ? _e : '').trim();
        const description = ((_f = row.data[++i]) !== null && _f !== void 0 ? _f : '').trim();
        const ecls = ((_g = row.data[++i]) !== null && _g !== void 0 ? _g : '').trim();
        const skills = ((_h = row.data[++i]) !== null && _h !== void 0 ? _h : '').trim();
        const trainingCourses = ((_j = row.data[++i]) !== null && _j !== void 0 ? _j : '').trim();
        const trainCourses = withTrainCourses ? ((_k = row.data[++i]) !== null && _k !== void 0 ? _k : '').trim() : '';
        const languages = ((_l = row.data[++i]) !== null && _l !== void 0 ? _l : '').trim();
        const state = ((_m = row.data[++i]) !== null && _m !== void 0 ? _m : '').trim();
        const counties = ((_o = row.data[++i]) !== null && _o !== void 0 ? _o : '').trim();
        const tribe = ((_p = row.data[++i]) !== null && _p !== void 0 ? _p : '').trim();
        const deploymentDuration = ((_q = row.data[++i]) !== null && _q !== void 0 ? _q : '').trim();
        const deploymentTravelWillingness = ((_r = row.data[++i]) !== null && _r !== void 0 ? _r : '').trim();
        const federalDeploymentWillingnessString = ((_s = row.data[++i]) !== null && _s !== void 0 ? _s : '').trim().toLowerCase();
        const federalDeploymentWillingness = federalDeploymentWillingnessString
            ? validateYesNoString(federalDeploymentWillingnessString)
            : undefined;
        const priorCommitmentsString = ((_t = row.data[++i]) !== null && _t !== void 0 ? _t : '').trim().toLowerCase();
        const priorCommitments = priorCommitmentsString ? validateYesNoString(priorCommitmentsString) : undefined;
        if (name.length === 0) {
            row.errors.push('Name is required');
        }
        if (status.length === 0) {
            row.errors.push('Status is required');
        }
        const { hasGroupNoOccupations, hasOccupationsNoGroup, hasOccupationGroup, hasOccupations } = validateOccupationsCriteria(occupationGroup, occupations);
        if (hasOccupationsNoGroup) {
            row.errors.push('Occupation group is missing');
        }
        if (hasGroupNoOccupations) {
            row.errors.push('Occupation is missing');
        }
        if (!hasOccupationGroup &&
            !hasOccupations &&
            !skills.length &&
            !trainingCourses.length &&
            (!withTrainCourses || !trainCourses.length) &&
            !languages.length) {
            row.errors.push(`At least one mission position criteria is required: occupation group and occupation, skills, training ${withTrainCourses ? 'or TRAIN ' : ''}courses or languages`);
        }
        if (state && counties && tribe) {
            row.errors.push('You must pick one: county or tribe');
        }
        if (counties && !state) {
            row.errors.push('State is missing');
        }
        switch (status) {
            case 'active':
            case 'deprecated':
            case 'retired':
                break;
            default:
                row.errors.push('Invalid status, expected one of: active, deprecated, retired');
        }
        const groupId = yield getClassifierIdByName('occupationGroup', occupationGroup, row.errors, 'Group not found: ' + occupationGroup);
        let occupationIds = undefined;
        if (groupId) {
            occupationIds = yield getClassifierIdsByNames('occupation', convertStringToArray(occupations), row.errors, 'Occupation not found: ', [
                { column: 'groupId', op: '=', value: groupId },
                { column: 'status', op: '=', value: 'active' },
            ]);
        }
        let eclValues;
        if (ecls) {
            const availableEclValues = occupationEcls.map((ecl) => ecl.label);
            const eclDataArr = convertStringToArray(ecls);
            const correctEclValues = eclDataArr.filter((ecl) => availableEclValues.includes(ecl));
            if (eclDataArr.length === correctEclValues.length) {
                const filteredEcls = occupationEcls.filter((ecl) => correctEclValues.includes(ecl.label));
                eclValues = filteredEcls.map((ecl) => ecl.value);
            }
            else {
                eclDataArr.forEach((ecl) => {
                    if (!availableEclValues.includes(ecl)) {
                        row.errors.push('ECL not found: ' + ecl);
                    }
                });
            }
        }
        const skillIds = yield getClassifierIdsByNames('skill', convertStringToArray(skills), row.errors, 'Skill not found: ');
        const trainingIds = yield getClassifierIdsByNames('training', convertStringToArray(trainingCourses), row.errors, 'Training Course not found: ');
        const trainCourseIds = withTrainCourses
            ? yield getClassifierIdsByNames('trainCourse', convertStringToArray(trainCourses), row.errors, 'TRAIN Course not found: ')
            : undefined;
        const languageIds = yield getClassifierIdsByNames('language', convertStringToArray(languages), row.errors, 'Language not found: ');
        const statePostalCode = yield getPostalCodeByName(state, row.errors, 'State not found: ' + state);
        const tribeIds = yield getClassifierIdsByNames('tribe', convertStringToArray(tribe), row.errors, 'Tribe not found: ' + tribe);
        if (counties) {
            yield getPostalCodesByNames(convertStringToArray(counties), row.errors, 'County not found: ', [
                { column: 'parentPostalCode', op: '=', value: statePostalCode },
                { column: 'type', op: '=', value: 'county' },
                { column: 'status', op: '=', value: 'active' },
            ]);
        }
        const deploymentDurationId = yield getClassifierIdByName('deploymentDuration', deploymentDuration, row.errors, 'Deployment duration not found: ');
        const deploymentTravelWillingnessIds = yield getClassifierIdsByNames('deploymentTravelWillingness', convertStringToArray(deploymentTravelWillingness), row.errors, 'Travel Willingness not found: ');
        const residenceType = counties ? 'county' : 'tribe';
        function validateYesNoString(val) {
            switch (val) {
                case 'yes':
                case 'no':
                    return val === 'yes';
                default:
                    row.errors.push(`Invalid value: ${val}. Valid values: yes, no`);
                    return undefined;
            }
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name,
                    status: status,
                    groupId,
                    occupationIds,
                    description,
                    ecl: eclValues,
                    skillIds,
                    trainingIds,
                    trainCourseIds,
                    languageIds,
                    state: statePostalCode !== null && statePostalCode !== void 0 ? statePostalCode : '',
                    residenceType,
                    counties: counties ? counties.split(',') : [],
                    tribeIds,
                    deploymentDurationId,
                    deploymentTravelWillingnessIds,
                    federalDeploymentWillingness,
                    priorCommitments,
                },
            };
        }
        return Promise.resolve(row);
    });
}
